import { render, staticRenderFns } from "./SystemRoleViewPage.vue?vue&type=template&id=ffbad81e&scoped=true&"
import script from "./SystemRoleViewPage.vue?vue&type=script&lang=js&"
export * from "./SystemRoleViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbad81e",
  null
  
)

export default component.exports